import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import { i18nData } from 'helpers/i18n';

import videoSlide from '../../baseSlides/videoSlide';
import balloonSlide from '../../baseSlides/balloonSlide';

import apprenticesPosing from '../../images/characters/apprenticesPosing.png';
import apprenticesFlexArms from '../../images/characters/apprenticesFlexArms.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFile_en from './song.md';
import markdownFile_fr_CA from './song.fr_CA.md';

const md = i18nData({
  en: new MarkdownScript(markdownFile_en),
  fr_CA: new MarkdownScript(markdownFile_fr_CA)
});

export function preloadSong () {
  preloader([
    apprenticesPosing,
    apprenticesFlexArms
  ]);
}

function songSection ({ level, regionData, i18n }) {
  const md_i18n = i18n(md);
  return (
    <Section id="song">

      {/* Speech bubble in levels 2,4,6 */}
      { (level === 2 || level === 4 || level === 6) &&
        balloonSlide({
          id: 'song-intro',
          characterSide: 'right',
          characterImage: apprenticesPosing,
          html: md_i18n.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      {/* Speech bubble in levels 1,3,5 */}
      { (level === 1 || level === 3 || level === 5) &&
        balloonSlide({
          id: 'intro',
          characterSide: 'right',
          characterImage: apprenticesFlexArms,
          html: md_i18n.getSubSectionAsHtml(`Level ${level} Intro`, 'Content', false, regionData),
          notes: md_i18n.getSubSectionAsHtml(`Level ${level} Intro`, 'Notes', false, regionData)
        })
      }

      {/* Song */}
      {videoSlide({
        id: 'video',
        notes: md_i18n.getSubSectionAsHtml('Song', 'Notes', false, regionData),
        youTubeId: md_i18n.getSectionMetadata('Song', 'YouTube', regionData)
      })}

    </Section>
  );
}

export default songSection;



// WEBPACK FOOTER //
// ./programs/keepCool/sections/03_song/songSection.jsx